import paper, { Path, view } from "paper";
import { settings } from "./store";

paper.install(window);
let paths: any[] = [];

window.onload = function () {
  // Setup directly from canvas id:
  paper.setup(settings.canvasId);
  view.onMouseDown = onMouseDown;
  view.onMouseDrag = onMouseDrag;
  view.onMouseUp = onMouseUp;
};

function cloneCanvas() {
  const image = view.context.getImageData(0, 0, 200, 200);
  var canvases = document.getElementsByClassName(
    "triangle"
  ) as HTMLCollectionOf<HTMLCanvasElement>;

  if (!image) return;

  // view.
  for (var i = 0; i < canvases.length; i++) {
    var newCanvas = canvases[i];

    var context = newCanvas.getContext("2d");

    newCanvas.width = view.element.width;
    newCanvas.height = view.element.height;

    context?.putImageData(image, 0, 0);
    // newCanvas.style.backgroundImage = `url(${view.element.toDataURL()})`;
  }
}

function onMouseDown(event: any) {
  paths.unshift(
    new Path({
      segments: [event.point],
      strokeColor: settings.strokeColor,
      strokeWidth: settings.strokeWidth,
      strokeCap: "round",
    })
  );
}

function onMouseDrag(event: any) {
  paths[0].add(event.point);
  cloneCanvas();
}

function onMouseUp() {
  paths[0].simplify(10);
  window.setTimeout(function () {
    cloneCanvas();
  }, 10);
}

globalThis.deletePath = function () {
  if (paths.length > 0) {
    paths[0].removeSegments();
    paths.shift();
    window.setTimeout(function () {
      cloneCanvas();
    }, 10);
  }
};
